import { __exports as core } from "../../../../_virtual/core.mjs";
import require$$0 from "../../../../_virtual/index2.mjs";
import require$$1 from "../../../../_virtual/index3.mjs";
import { __require as requireGetDurationUnitOptions } from "./abstract/GetDurationUnitOptions.mjs";
import { __require as requirePartitionDurationFormatPattern } from "./abstract/PartitionDurationFormatPattern.mjs";
import { __require as requireToDurationRecord } from "./abstract/ToDurationRecord.mjs";
import { __require as requireGet_internal_slots } from "./get_internal_slots.mjs";
import { __require as requireNumberingSystems_generated } from "./numbering-systems.generated.mjs";
import { __require as requireTimeSeparators_generated } from "./time-separators.generated.mjs";
var hasRequiredCore;
function requireCore() {
  if (hasRequiredCore) return core;
  hasRequiredCore = 1;
  Object.defineProperty(core, "__esModule", { value: true });
  core.DurationFormat = void 0;
  var ecma402_abstract_1 = require$$0;
  var intl_localematcher_1 = require$$1;
  var GetDurationUnitOptions_1 = requireGetDurationUnitOptions();
  var PartitionDurationFormatPattern_1 = requirePartitionDurationFormatPattern();
  var ToDurationRecord_1 = requireToDurationRecord();
  var get_internal_slots_1 = requireGet_internal_slots();
  var numbering_systems_generated_1 = requireNumberingSystems_generated();
  var time_separators_generated_1 = requireTimeSeparators_generated();
  var RESOLVED_OPTIONS_KEYS = [
    "locale",
    "style",
    "years",
    "yearsDisplay",
    "months",
    "monthsDisplay",
    "weeks",
    "weeksDisplay",
    "days",
    "daysDisplay",
    "hours",
    "hoursDisplay",
    "minutes",
    "minutesDisplay",
    "seconds",
    "secondsDisplay",
    "milliseconds",
    "millisecondsDisplay",
    "microseconds",
    "microsecondsDisplay",
    "nanoseconds",
    "nanosecondsDisplay",
    "numberingSystem",
    "fractionalDigits"
  ];
  var TABLE_3 = [
    {
      styleSlot: "years",
      displaySlot: "yearsDisplay",
      unit: "years",
      values: ["long", "short", "narrow"],
      digitalDefault: "short"
    },
    {
      styleSlot: "months",
      displaySlot: "monthsDisplay",
      unit: "months",
      values: ["long", "short", "narrow"],
      digitalDefault: "short"
    },
    {
      styleSlot: "weeks",
      displaySlot: "weeksDisplay",
      unit: "weeks",
      values: ["long", "short", "narrow"],
      digitalDefault: "short"
    },
    {
      styleSlot: "days",
      displaySlot: "daysDisplay",
      unit: "days",
      values: ["long", "short", "narrow"],
      digitalDefault: "short"
    },
    {
      styleSlot: "hours",
      displaySlot: "hoursDisplay",
      unit: "hours",
      values: ["long", "short", "narrow", "numeric", "2-digit"],
      digitalDefault: "numeric"
    },
    {
      styleSlot: "minutes",
      displaySlot: "minutesDisplay",
      unit: "minutes",
      values: ["long", "short", "narrow", "numeric", "2-digit"],
      digitalDefault: "numeric"
    },
    {
      styleSlot: "seconds",
      displaySlot: "secondsDisplay",
      unit: "seconds",
      values: ["long", "short", "narrow", "numeric", "2-digit"],
      digitalDefault: "numeric"
    },
    {
      styleSlot: "milliseconds",
      displaySlot: "millisecondsDisplay",
      unit: "milliseconds",
      values: ["long", "short", "narrow", "numeric"],
      digitalDefault: "numeric"
    },
    {
      styleSlot: "microseconds",
      displaySlot: "microsecondsDisplay",
      unit: "microseconds",
      values: ["long", "short", "narrow", "numeric"],
      digitalDefault: "numeric"
    },
    {
      styleSlot: "nanoseconds",
      displaySlot: "nanosecondsDisplay",
      unit: "nanoseconds",
      values: ["long", "short", "narrow", "numeric"],
      digitalDefault: "numeric"
    }
  ];
  var DurationFormat = (
    /** @class */
    function() {
      function DurationFormat2(locales, options) {
        var newTarget = this && this instanceof DurationFormat2 ? this.constructor : void 0;
        if (!newTarget) {
          throw new TypeError("Intl.DurationFormat must be called with 'new'");
        }
        var requestedLocales = (0, ecma402_abstract_1.CanonicalizeLocaleList)(locales);
        var opt = /* @__PURE__ */ Object.create(null);
        var opts = options === void 0 ? /* @__PURE__ */ Object.create(null) : (0, ecma402_abstract_1.ToObject)(options);
        var matcher = (0, ecma402_abstract_1.GetOption)(opts, "localeMatcher", "string", ["best fit", "lookup"], "best fit");
        var numberingSystem = (0, ecma402_abstract_1.GetOption)(opts, "numberingSystem", "string", void 0, void 0);
        if (numberingSystem !== void 0 && numbering_systems_generated_1.numberingSystemNames.indexOf(numberingSystem) < 0) {
          throw RangeError("Invalid numberingSystems: ".concat(numberingSystem));
        }
        opt.nu = numberingSystem;
        opt.localeMatcher = matcher;
        var localeData = DurationFormat2.localeData, availableLocales = DurationFormat2.availableLocales;
        var r = (0, intl_localematcher_1.ResolveLocale)(
          availableLocales,
          requestedLocales,
          opt,
          // [[RelevantExtensionKeys]] slot, which is a constant
          ["nu"],
          localeData,
          DurationFormat2.getDefaultLocale
        );
        var locale = r.locale;
        var internalSlots = (0, get_internal_slots_1.getInternalSlots)(this);
        internalSlots.initializedDurationFormat = true;
        internalSlots.locale = locale;
        internalSlots.numberingSystem = r.nu;
        var style = (0, ecma402_abstract_1.GetOption)(opts, "style", "string", ["long", "short", "narrow", "digital"], "short");
        internalSlots.style = style;
        internalSlots.dataLocale = r.dataLocale;
        var prevStyle = "";
        TABLE_3.forEach(function(row) {
          var styleSlot = row.styleSlot, displaySlot = row.displaySlot, unit = row.unit, valueList = row.values, digitalBase = row.digitalDefault;
          var unitOptions = (0, GetDurationUnitOptions_1.GetDurationUnitOptions)(unit, opts, style, valueList, digitalBase, prevStyle);
          internalSlots[styleSlot] = unitOptions.style;
          internalSlots[displaySlot] = unitOptions.display;
          if (unit === "hours" || unit === "minutes" || unit === "seconds" || unit === "milliseconds" || unit === "microseconds") {
            prevStyle = unitOptions.style;
          }
        });
        internalSlots.fractionalDigits = (0, ecma402_abstract_1.GetNumberOption)(opts, "fractionalDigits", 0, 9, void 0);
      }
      DurationFormat2.prototype.resolvedOptions = function() {
        if (typeof this !== "object" || !(0, ecma402_abstract_1.OrdinaryHasInstance)(DurationFormat2, this)) {
          throw TypeError("Method Intl.DurationFormat.prototype.resolvedOptions called on incompatible receiver");
        }
        var internalSlots = (0, get_internal_slots_1.getInternalSlots)(this);
        var ro = {};
        for (var _i = 0, RESOLVED_OPTIONS_KEYS_1 = RESOLVED_OPTIONS_KEYS; _i < RESOLVED_OPTIONS_KEYS_1.length; _i++) {
          var key = RESOLVED_OPTIONS_KEYS_1[_i];
          var v = internalSlots[key];
          if (key === "fractionalDigits") {
            if (v !== void 0) {
              v = Number(v);
            }
          } else {
            (0, ecma402_abstract_1.invariant)(v !== void 0, "Missing internal slot ".concat(key));
          }
          ro[key] = v;
        }
        return ro;
      };
      DurationFormat2.prototype.formatToParts = function(duration) {
        var df = this;
        var locInternalSlots = (0, get_internal_slots_1.getInternalSlots)(this);
        if (locInternalSlots.initializedDurationFormat === void 0) {
          throw new TypeError("Error uninitialized locale");
        }
        var record = (0, ToDurationRecord_1.ToDurationRecord)(duration);
        var parts = (0, PartitionDurationFormatPattern_1.PartitionDurationFormatPattern)(df, record);
        var result = [];
        for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
          var _a = parts_1[_i], type = _a.type, unit = _a.unit, value = _a.value;
          var obj = { type, value };
          if (unit) {
            obj.unit = unit;
          }
          result.push(obj);
        }
        return result;
      };
      DurationFormat2.prototype.format = function(duration) {
        var df = this;
        var locInternalSlots = (0, get_internal_slots_1.getInternalSlots)(this);
        if (locInternalSlots.initializedDurationFormat === void 0) {
          throw new TypeError("Error uninitialized locale");
        }
        var record = (0, ToDurationRecord_1.ToDurationRecord)(duration);
        var parts = (0, PartitionDurationFormatPattern_1.PartitionDurationFormatPattern)(df, record);
        var result = "";
        for (var _i = 0, parts_2 = parts; _i < parts_2.length; _i++) {
          var value = parts_2[_i].value;
          result += value;
        }
        return result;
      };
      DurationFormat2.supportedLocalesOf = function(locales, options) {
        return (0, ecma402_abstract_1.SupportedLocales)(DurationFormat2.availableLocales, (0, ecma402_abstract_1.CanonicalizeLocaleList)(locales), options);
      };
      DurationFormat2.__defaultLocale = "en";
      DurationFormat2.availableLocales = /* @__PURE__ */ new Set();
      DurationFormat2.localeData = Object.keys(time_separators_generated_1.TIME_SEPARATORS.localeData).reduce(function(all, locale) {
        DurationFormat2.availableLocales.add(locale);
        var nu = time_separators_generated_1.TIME_SEPARATORS.localeData[locale].nu;
        all[locale] = {
          nu,
          digitalFormat: time_separators_generated_1.TIME_SEPARATORS.localeData[locale].separator || nu.reduce(function(separators, n) {
            separators[n] = time_separators_generated_1.TIME_SEPARATORS.default;
            return separators;
          }, {})
        };
        return all;
      }, {});
      DurationFormat2.getDefaultLocale = function() {
        return DurationFormat2.__defaultLocale;
      };
      DurationFormat2.polyfilled = true;
      return DurationFormat2;
    }()
  );
  core.DurationFormat = DurationFormat;
  return core;
}
export {
  requireCore as __require
};
